import React from 'react';
import {
    Title, Container, OfferRowWrapper, ContentContainer,
    BenefitWrapper, BenefitIconWrapper, OfferTypeText,
    PricingTitleContainer, PricingContainer,
    PricingTitle, PricingSubtitle, OfferTypeDivider, OfferRowLabel,
    OfferRowPrice, BenefitTitle, OfferChangeTypeContainer,
    OfferChangeTypeDescription, OfferChangeTypeAction, OfferRowContainer,
    OfferRowOldPrice, PricingTitleContainerTitle, PricingTitleValidUntilValue, PricingTitleValidUntilDescription, BenefitText, OfferShortDescription
} from './style';
import { ReactComponent as CircleTicked } from "../../static/images/circle-ticked.svg";
import { THEME_COLORS } from '../../styles/theme';
import { OFFER_TYPE } from '../../reducers/offer';
import IconsOffer from '../IconsOffer';
import { connect } from 'react-redux';
import { changeOfferTypeSetPopupOpen } from '../../reducers/changeOfferType';
import { GreenLeaf } from '../Icons/SVG';

const OfferComponent = ({
    energy = [], gas = [], benefits = [], name = '', validUntil,
    shortDescription, isGreenEnergy,
    offerType = '', icon, isMobile = false, openChangeOfferType
}) => {
    return (
        <Container isMobile={isMobile}>
            <IconsOffer icon={icon} />
            <Title>{name}</Title>
            <OfferShortDescription>{shortDescription}</OfferShortDescription>
            <PricingTitleContainer>
                <PricingTitleContainerTitle>Condizioni</PricingTitleContainerTitle>
                <PricingTitleValidUntilDescription>valide fino al <PricingTitleValidUntilValue>{validUntil}</PricingTitleValidUntilValue></PricingTitleValidUntilDescription>
            </PricingTitleContainer>

            <ContentContainer>
                {energy.length > 0 &&
                    <PricingContainer borderColor="#f88a2e">
                        <PricingTitle themeColor={THEME_COLORS.orange}>Energia</PricingTitle>
                        <PricingSubtitle>Prezzo materia prima</PricingSubtitle>
                        {!name.includes('VIVIpartner')&& (
                        <OfferTypeText>{offerType === OFFER_TYPE.bio ? 'BIORARIA' : 'MONORARIA'}</OfferTypeText>
                        )}
                        {name.includes('VIVIpartner')&& (
                        <OfferTypeText>BIORARIA</OfferTypeText>
                        )}
                        <OfferTypeDivider color={THEME_COLORS.orange} />
                        {energy.map(v => (
                            <OfferRowContainer key={v.label}>
                                <OfferRowOldPrice>{v.oldValue}</OfferRowOldPrice>
                                <OfferRowWrapper>
                                    <OfferRowLabel>{v.label}</OfferRowLabel>
                                    <OfferRowPrice>{v.value}</OfferRowPrice>
                                </OfferRowWrapper>
                            </OfferRowContainer>
                        ))}
                        {!name.includes('VIVIpartner')&& (
                            <OfferChangeTypeContainer>
                                <OfferChangeTypeDescription>Hai cambiato idea?</OfferChangeTypeDescription>
                                <OfferChangeTypeAction onClick={openChangeOfferType}>
                                    Passa all'opzione {offerType === OFFER_TYPE.bio ? 'monoraria' : 'bioraria'}
                                </OfferChangeTypeAction>
                            </OfferChangeTypeContainer>
                        )}

                    </PricingContainer>
                }

                {gas.length > 0 &&
                    <PricingContainer borderColor="#077bbe">
                        <div style={{ backgroundColor: 'white', zIndex: 10 }}>
                            <PricingTitle themeColor={THEME_COLORS.lightBlue}>Gas</PricingTitle>
                            <PricingSubtitle>Prezzo materia prima</PricingSubtitle>
                            {gas.map(v => (
                                <OfferRowContainer key={v.label}>
                                    <OfferRowOldPrice>{v.oldValue}</OfferRowOldPrice>
                                    <OfferRowWrapper key={v.label}>
                                        <OfferRowLabel>{v.label}</OfferRowLabel>
                                        <OfferRowPrice>{v.value}</OfferRowPrice>
                                    </OfferRowWrapper>
                                </OfferRowContainer>
                            ))}
                        </div>
                    </PricingContainer>
                }
                {benefits.length > 0 &&
                    <div style={{ paddingTop: '10px' }}>
                        <BenefitTitle>Vantaggi</BenefitTitle>
                        {benefits.map(v => (
                            <BenefitWrapper key={v}>
                                <BenefitIconWrapper>
                                    <CircleTicked />
                                </BenefitIconWrapper>
                                <BenefitText dangerouslySetInnerHTML={{ __html: `${v}` }} />
                            </BenefitWrapper>
                        ))}
                        {isGreenEnergy && <BenefitWrapper>
                            <BenefitIconWrapper>
                                <GreenLeaf />
                            </BenefitIconWrapper>
                            <BenefitText textColor={THEME_COLORS.green}>Energia verde</BenefitText>
                        </BenefitWrapper>}

                    </div>
                }
            </ContentContainer>
        </Container>
    );
}

export const Offer = connect(
    (state) => ({

    }), dispatch => ({
        openChangeOfferType: () => dispatch(changeOfferTypeSetPopupOpen(true)),
    })
)(OfferComponent);
